import Vue from 'vue'
import App from './App.vue'

import './plugins/axios';
import { store } from './store/store';
import { gsap } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueConfetti from 'vue-confetti';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import sounds from "vue-sounds";
import VueTagManager from "vue-tag-manager"
import router from "./router";
import {Howl, Howler} from 'howler';


Vue.use(VueTagManager, {
  gtmId: 'GTM-NMC54M5'
})

Vue.use(sounds, store);

Howler.volume(0.07);

import VueTimers from 'vue-timers'

Vue.use(VueTimers)

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(VueConfetti);

gsap.registerPlugin(CSSPlugin)
Vue.use(VueYouTubeEmbed, { global: true, componentId: "youtube-media" })


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

